document.addEventListener('DOMContentLoaded', function () {
    // EUA URL
 
    var url = window.location.href
    var urlsplit = url.split("?")[0];
    if (urlsplit == 'https://weasypet.com/') {

        var divs = document.querySelectorAll('div[reveal-on-scroll="true"]');
        for (var i = 0; i < divs.length; i++) {
            var imgs = divs[i].querySelectorAll('img');
            for (var j = 0; j < imgs.length; j++) {
                imgs[j].addEventListener('click', function () {
                    window.location.href = 'https://weasypet.com/products/weasy-for-dogs';
                });
            }

        }

        var divs = document.querySelectorAll('div.media-with-text__media[reveal-on-scroll="true"]');

        for (var i = 0; i < divs.length; i++) {
            divs[i].addEventListener('click', function () {
                window.location.href = 'https://weasypet.com/products/weasy-for-dogs';
            });
        }

        var imageBanners = document.querySelectorAll('image-banner');

        for (var i = 0; i < imageBanners.length; i++) {
            var imgs = imageBanners[i].querySelectorAll('img');
            for (var j = 0; j < imgs.length; j++) {
                imgs[j].addEventListener('click', function () {
                    window.location.href = 'https://weasypet.com/products/weasy-for-dogs';
                });
            }
        }

        var divs2 = document.querySelectorAll('.media-with-text__item');
        // adicionar a classe 'weasy-card' a cada div
        for (var i = 0; i < divs2.length; i++) {
            divs2[i].classList.add('weasy-card');
        }
        console.log("pagina inicial eua");
    }

    // en-ca URL
    if (urlsplit == 'https://weasypet.com/en-ca') {
        var divs = document.querySelectorAll('div[reveal-on-scroll="true"]');
        for (var i = 0; i < divs.length; i++) {
            var imgs = divs[i].querySelectorAll('img');
            for (var j = 0; j < imgs.length; j++) {
                imgs[j].addEventListener('click', function () {
                    window.location.href = 'https://weasypet.com/en-ca/products/weasy-for-dogs';
                });
            }
        }

        var divs = document.querySelectorAll('div.media-with-text__media[reveal-on-scroll="true"]');

        for (var i = 0; i < divs.length; i++) {
            divs[i].addEventListener('click', function () {
                window.location.href = 'https://weasypet.com/en-ca/products/weasy-for-dogs';
            });
        }

        var imageBanners = document.querySelectorAll('image-banner');

        for (var i = 0; i < imageBanners.length; i++) {
            var imgs = imageBanners[i].querySelectorAll('img');
            for (var j = 0; j < imgs.length; j++) {
                imgs[j].addEventListener('click', function () {
                    window.location.href = 'https://weasypet.com/en-ca/products/weasy-for-dogs';
                });
            }
        }


        var divs2 = document.querySelectorAll('.media-with-text__item');
        // adicionar a classe 'weasy-card' a cada div
        for (var i = 0; i < divs2.length; i++) {
            divs2[i].classList.add('weasy-card');
        }
        console.log("pagina inicial en-ca");
    }


    // en-gb URL
    if (urlsplit == 'https://weasypet.com/en-gb') {
        var divs = document.querySelectorAll('div[reveal-on-scroll="true"]');
        for (var i = 0; i < divs.length; i++) {
            var imgs = divs[i].querySelectorAll('img');
            for (var j = 0; j < imgs.length; j++) {
                imgs[j].addEventListener('click', function () {
                    window.location.href = 'https://weasypet.com/en-gb/products/weasy-for-dogs';
                });
            }
        }

        var divs = document.querySelectorAll('div.media-with-text__media[reveal-on-scroll="true"]');

        for (var i = 0; i < divs.length; i++) {
            divs[i].addEventListener('click', function () {
                window.location.href = 'https://weasypet.com/en-gb/products/weasy-for-dogs';
            });
        }

        var imageBanners = document.querySelectorAll('image-banner');

        for (var i = 0; i < imageBanners.length; i++) {
            var imgs = imageBanners[i].querySelectorAll('img');
            for (var j = 0; j < imgs.length; j++) {
                imgs[j].addEventListener('click', function () {
                    window.location.href = 'https://weasypet.com/en-gb/products/weasy-for-dogs';
                });
            }
        }


        var divs2 = document.querySelectorAll('.media-with-text__item');
        // adicionar a classe 'weasy-card' a cada div
        for (var i = 0; i < divs2.length; i++) {
            divs2[i].classList.add('weasy-card');
        }
        console.log("pagina inicial en-gb");
    }


});


